export const primary_color = "#3b86ff";